import { ActivatedRoute, Router } from "@angular/router";
import { EMPTY_PIECE, EMPTY_SHIPMENT, Piece, Shipment } from "../interfaces";
import { BackendService } from "../services/backend.service";
import { UserService } from "../services/user.service";
import { PieceWrapper } from "./piece-wrapper";
import { ShipmentWrapper } from "./shipment-wrapper";

export class DataProvider {
  placeholder = 'placeholder';


  piece: PieceWrapper;

  shipment: ShipmentWrapper;

  pieceUrl: string | null = null;

  shipmentUrl!: string;

  backend: BackendService;

  otherPieces: PieceWrapper[] = [];

  route!: ActivatedRoute;

  router!: Router;

  loadPieces = true;

  userService: UserService;

  constructor(route: ActivatedRoute, backend: BackendService, router: Router, loadPieces: boolean, userService: UserService) {
    this.backend = backend;
    this.route = route;
    this.router = router;
    this.loadPieces = loadPieces;
    this.userService = userService;
    this.shipment = new ShipmentWrapper(EMPTY_SHIPMENT, userService);
    this.piece = new PieceWrapper(EMPTY_PIECE, userService);
    route.paramMap.subscribe(() => this.refresh());

  }

  click(e: PieceWrapper) {
    const curPath = this.route.routeConfig?.path;
    console.log('clicked', e.id, curPath);
    if (e.id && curPath) {
      this.router.navigate([curPath, { url: e.id }]);
    }
  }

  idsEqual(id1: string, id2: string) {
    const url1 = new URL(id1);
    const url2 = new URL(id2);
    return url1.pathname === url2.pathname;
  }

  refresh(): void {
    this.pieceUrl = this.route.snapshot.paramMap.get('url');
    if (this.pieceUrl) {
      this.backend.getLos(this.pieceUrl).subscribe(data => {
        this.piece = new PieceWrapper(data as Piece, this.userService);
        const shipmentId = this.piece.shipmentId;
        this.otherPieces = [this.piece];
        if (shipmentId) {
          this.shipmentUrl = shipmentId;
          this.backend.getLos(this.shipmentUrl).subscribe(data => {
            this.shipment = new ShipmentWrapper(data as Shipment, this.userService);
            if (this.loadPieces) {
              this.shipment.containedPieces.forEach(piece => {
                const id = piece['@id'];
                if (!this.idsEqual(id, this.pieceUrl ?? '')) {
                  this.backend.getLos(id).subscribe(data => {
                    this.otherPieces.push(new PieceWrapper(data as Piece, this.userService));
                    this.otherPieces = [...this.otherPieces];
                  });
                }
              });
            }
          });
        } else {
          this.shipment = new ShipmentWrapper(EMPTY_SHIPMENT, this.userService);
          this.otherPieces = [];
        }
      });
    } else {
      this.piece = new PieceWrapper(EMPTY_PIECE, this.userService);
      this.shipment = new ShipmentWrapper(EMPTY_SHIPMENT, this.userService);
    }
  }

  isCha(): boolean {
    return this.userService.currentUser()?.username === 'CHA';
  }





}
